import { render } from "./Status.vue?vue&type=template&id=25182e16&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=25182e16&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25182e16"]])

export default __exports__